import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import CreateTimeRegMutation from '../../../../../mutations/ticketing/tickets/createTimeRegMutation';

export interface LogTimeToTaskInput {
	taskId: string;
	projectId: string | null;
	year: number;
	month: number;
	day: number;
	minutesRegistered: number;
	roleId?: string | null;
	notes?: string | null;
	personId: string;
}

export interface LoggedTimeTask {
	id: string;
	totalMinutesRegistered: number | null;
}

export function useLogTimeToTask() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function submit(input: LogTimeToTaskInput): Promise<LoggedTimeTask> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				CreateTimeRegMutation,
				input,
				response => {
					setLoading(false);
					const payload = response.createTimeReg;
					const errors: string[] | null = payload?.errors ?? null;
					if (errors && errors.length > 0) {
						const msg = errors[0];
						setError(msg);
						reject(new Error(msg));
						return;
					}
					const task = payload?.task;
					resolve({id: task?.id ?? input.taskId, totalMinutesRegistered: task?.totalMinutesRegistered ?? null});
				},
				err => {
					setLoading(false);
					setError(err instanceof Error ? err.message : String(err));
					reject(err);
				}
			);
		});
	}

	return {submit, loading, error};
}
